var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.messagetype === 'cards')?_c('span',[_vm._v("\n  "+_vm._s(_vm.$t("CONVERSATION.UNSUPPORTED.CAROUSEL"))+"\n")]):_c('span',[_vm._v("\n  "+_vm._s(_vm.$t("CONVERSATION.UNSUPPORTED.MEDIA"))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }